import { Modal } from 'antd';
import qs from 'qs';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { createEnterprise, getEnterpriseTags } from '../../api/constlink';
import EnterpriseCreateUpdateComponent from '../../components/auth/EnterpriseCreateUpdateComponent';
import { Enterprise, Tag } from '../../modules/auth';

function EnterpriseCreateContainer({ history }: RouteComponentProps) {
  const [gongjongs, setGongjongs] = useState<Tag[]>();
  const [materialVendorTypes, setMaterialVendorTypes] = useState<Tag[]>();
  const { redirectUrl } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  useEffect(() => {
    (async () => {
      setGongjongs(await getEnterpriseTags('gongjong'));
    })();
    (async () => {
      setMaterialVendorTypes(await getEnterpriseTags('materialVendorType'));
    })();
  }, []);

  const onCreate = async (enterprise: Enterprise) => {
    try {
      const data: any = await createEnterprise(enterprise);
      if (data.status === 'fail')
        Modal.warning({ content: '이미 회사를 생성 하셨습니다.' });
      else
        Modal.success({
          content: '내 회사를 생성 하였습니다.',
          onOk() {
            history.push(`select-enterprise?redirectUrl=${redirectUrl}`);
          },
        });
    } catch (e: any) {
      Modal.warning({ content: '내 회사 생성을 실패 하였습니다.' });
    }
  };

  const onCancel = () => {
    history.push(`select-enterprise?redirectUrl=${redirectUrl}`);
  };

  return (
    <>
      {gongjongs && materialVendorTypes && (
        <EnterpriseCreateUpdateComponent
          onCreate={onCreate}
          onCancel={onCancel}
          gongjongs={gongjongs}
          materialVendorTypes={materialVendorTypes}
        />
      )}
    </>
  );
}

export default EnterpriseCreateContainer;
